// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-page-change-password h1 {
  margin-top: 1rem;
}
.lsn-page-change-password .show-password-input-container .show-password-btn {
  position: absolute;
  top: var(--main-font-size-control);
  transform: translateY(-50%);
  right: 1rem;
}
.lsn-page-change-password .show-password-input-container .show-password-btn i.fa {
  cursor: pointer;
  font-size: var(--main-font-size-primary);
  line-height: normal;
  display: block;
  color: var(--main-medium-gray);
}
.password-validator-container {
  margin-top: 1.5rem;
}
.change-password-success-modal-body {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/forgotPassword/ChangePassword.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;AAAJ;AAFA;EAOM,kBAAA;EACA,kCAAA;EACA,2BAAA;EACA,WAAA;AAFN;AARA;EAaQ,eAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;AAFR;AAQA;EACE,kBAAA;AANF;AASA;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AAPF","sourcesContent":[".lsn-page-change-password {\n  h1 {\n    margin-top: 1rem;\n  }\n\n  .show-password-input-container {\n    .show-password-btn {\n      position: absolute;\n      top: var(--main-font-size-control);\n      transform: translateY(-50%);\n      right: 1rem;\n\n      i.fa {\n        cursor: pointer;\n        font-size: var(--main-font-size-primary);\n        line-height: normal;\n        display: block;\n        color: var(--main-medium-gray);\n      }\n    }\n  }\n}\n\n.password-validator-container {\n  margin-top: 1.5rem;\n}\n\n.change-password-success-modal-body {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 1rem;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
